export const carouselTokens = {
  carousel: {
    root: {
      transitionDuration: '{transition.duration}'
    },
    content: {
      gap: '0.25rem'
    },
    indicatorList: {
      padding: '0',
      gap: '0.5rem'
    },
    indicator: {
      width: '0.625rem',
      height: '0.625rem',
      borderRadius: '50%',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: '{focus.ring.shadow}'
      }
    },
    colorScheme: {
      light: {
        indicator: {
          background: 'transparent',
          hoverBackground: '{surface.300}',
          activeBackground: '{primary.color}'
        }
      },
      dark: {
        indicator: {
          background: '{surface.700}',
          hoverBackground: '{surface.600}',
          activeBackground: '{primary.color}'
        }
      }
    }
  }
};

export type CarouselTokens = typeof carouselTokens;
